module.exports = __webpack_public_path__ + "static/media/savechanges.af687ad4.png";